export const DOCUMENT_CODE_MAX_LENGTH = 20;

const DOCUMENT_CODE_ALLOWED_CHARS_PATTERN = /^[A-Za-z0-9\-.#]+$/;
const DIGITS_ONLY_PATTERN = /^\d+$/;

const DOCUMENT_CODE_ERROR_MESSAGE_KEYS = {
  document_code_already_exists: 'newDocument.documentCodeAlreadyExists',
  document_code_too_long: 'forms.documentCodeTooLong',
  document_code_invalid_characters: 'forms.documentCodeInvalidCharacters',
} as const;

export type DocumentCodeErrorSlug =
  keyof typeof DOCUMENT_CODE_ERROR_MESSAGE_KEYS;

const isDocumentCodeErrorSlug = (
  slug?: string,
): slug is DocumentCodeErrorSlug =>
  slug !== undefined && slug in DOCUMENT_CODE_ERROR_MESSAGE_KEYS;

const matchesTemplateCodePattern = (code: string, templatePrefix?: string) => {
  if (!templatePrefix) return false;
  return (
    code.startsWith(templatePrefix) &&
    DIGITS_ONLY_PATTERN.test(code.slice(templatePrefix.length))
  );
};

export const getDocumentCodeErrorSlug = (
  code: string,
  templatePrefix?: string,
): DocumentCodeErrorSlug | undefined => {
  const hasInvalidCharacters =
    code !== '' && !DOCUMENT_CODE_ALLOWED_CHARS_PATTERN.test(code);
  const isTooLong =
    code.length > DOCUMENT_CODE_MAX_LENGTH &&
    !matchesTemplateCodePattern(code, templatePrefix);

  if (hasInvalidCharacters) return 'document_code_invalid_characters';
  if (isTooLong) return 'document_code_too_long';
  return undefined;
};

export const getDocumentCodeErrorMessageKey = (slug?: string) =>
  isDocumentCodeErrorSlug(slug)
    ? DOCUMENT_CODE_ERROR_MESSAGE_KEYS[slug]
    : undefined;
